import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RegisterResultViewModel } from '../../../models/register-result-view-model';
import { UserViewModel } from '../../../models/user-view-model';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../../../services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDataStoreService } from '../../../services/user-data-store.service';
import { FormBuilder } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormatHelper } from '../../../helpers/format-helper';
import { ParticipantService } from '../../../services/participant.service';
import { ReportService } from '../../../services/report.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DataTablesResponseViewModel } from '../../../models/data-tables-response-view-model';
import { MerchantReportDTViewModel } from '../../../models/merchant-report-dt-view-model';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { UserManagementService } from '../../../services/user-management.service';
import { PermissionEnum } from '../../../services/guards/permissions';
import { CreateResult } from '../../../models/create-result';
import { MerchantReportUserLinkDTViewModel } from '../../../models/merchant-report-user-link-dt-view-model';
import { TerminalReportUserLinkDTViewModel } from '../../../models/terminal-report-user-link-dt-view-model';
import { ConfirmationDialogComponent } from '../../../partials/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-report-user-view-management',
  templateUrl: './report-user-view-management.component.html',
  styleUrls: ['./report-user-view-management.component.scss']
})
export class ReportUserViewManagementComponent implements OnInit {

  public registerResult: RegisterResultViewModel;
  public user: UserViewModel = {
    email: '',
    name: '',
    lastName: '',
    phoneNumber: '',
    roles: [],
    participants: []
  };
  public createResult: CreateResult;
  public canManage: boolean;
  public dtOptions: DataTables.Settings = {};
  private _destroyed$ = new Subject<any>();
  public dtTrigger: Subject<boolean> = new Subject();
  public merchants: MerchantReportDTViewModel[];
  public merchantreports: MerchantReportUserLinkDTViewModel[];
  public terminalreports: TerminalReportUserLinkDTViewModel[];
  public dtElement: DataTableDirective;
  public globalSearch: boolean;
  public descriptionSearch = '';
  public merchantIdSearch = '';
  public usnNumberSearch = '';
  public clientSearch = '';
  public selectedTerminal = "";

  public parts: string[] = null;
  public userId: string;

  public UserName: string;
  public lastLogin: Date;
  public lastName: string;
  public name: string;
  public defaultParticipant: number;

  constructor(private _changeDetectorRef: ChangeDetectorRef,
    private _toastService: ToastrService,
    private _modalService: NgbModal,
    private _authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private _userDataStore: UserDataStoreService,
    private _router: Router,
    private fb: FormBuilder,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _formBuilder: FormBuilder,
    private _formatHelper: FormatHelper,
    private _reportService: ReportService,
    private _ngxLoader: NgxUiLoaderService,
    private _participantService: ParticipantService,
    private _httpClient: HttpClient,
    private _userManagementService: UserManagementService) {

    this.canManage = this._userDataStore.hasRequiredPermissions([PermissionEnum.ManageTutukaManagementReportSetups]);
    if (!this.canManage) {
      this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
      this._router.navigate(['/']);
    }

    route.params.pipe(takeUntil(this._destroyed$)).subscribe(async params => {
      this.user = await this._reportService.GetByUserId(params.id);
      this.UserName = this.user.email;
      this.lastLogin = this.user.lastLogin;
      this.lastName = this.user.lastName;
      this.name = this.user.name

      this.userId = params.id;
      this.user.participants.forEach(function (value) {
        console.log(value);
      });

      debugger;
      this.defaultParticipant = _userDataStore.selectedParticipant.id;
      if (this.user.participants.length >= 1) {
        this.merchants = await this._reportService.GetAllMerchantsByParticipants("" + this.defaultParticipant);
        this.dtTrigger.next();
      }


      this.merchantreports = await this._reportService.GetAllMerchantsLinksByUser(this.user.id);
    });

  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
  }

  private resetDatatable(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  public async save(): Promise<void> {

  }

  public ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
    this.dtTrigger.unsubscribe();
  }

  public async linkMerchant(merchant: MerchantReportDTViewModel): Promise<void> {
    debugger;
    this._ngxUiLoaderService.start();
    this.createResult = await this._reportService.LinkUserToMerchant("" + merchant.merchantID, this.userId);
    if (this.createResult.success == true) {
      this._toastService.success(this.createResult.message, "Success");
    }
    else {
      this._toastService.error(this.createResult.message, "Error");
    }

    this.merchantreports = await this._reportService.GetAllMerchantsLinksByUser(this.userId);

    this._ngxUiLoaderService.stop();
  }


  public async viewTerminals(merchant: MerchantReportUserLinkDTViewModel): Promise<void> {
    this._ngxUiLoaderService.start();

    this.terminalreports = await this._reportService.GetAllTerminalsReportsLinkByUser(merchant.merchantId, this.userId);

    await this.openUsedDeleteFailureConfirmationDialog(this.terminalreports.map(td => 'Terminal Number: ' + td.terminalNumber));
    this._ngxUiLoaderService.stop();
  }

  public async openUsedDeleteFailureConfirmationDialog(terminals: string[]) {
    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.acceptButtonText = "OK"
    dialogRef.componentInstance.title = "Terminals linked to the merchant."
    //dialogRef.componentInstance.message = "This Terminal Config is currently in use and cannot be deleted.<br/><br/><b>Terminals using config:</b>"
    dialogRef.componentInstance.listMessage = terminals;
    dialogRef.componentInstance.listMessageHtml;
  }

  public async openDeleteConfirmDialog(merchant: MerchantReportUserLinkDTViewModel) {
    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = 'Yes';
    dialogRef.componentInstance.cancelButtonText = 'No'
    dialogRef.componentInstance.title = 'Merchant User link Removal'
    dialogRef.componentInstance.message = 'Are you sure you want to delete the Merchant User Link?'

    const result = await dialogRef.result;
    if (result) {

      this._ngxUiLoaderService.start();

      this.createResult = await this._reportService.deleteUserLinkToMerchant("" + merchant.merchantId, this.userId);
      if (this.createResult.success == true) {
        this._toastService.success(this.createResult.message, "Success");
      }
      else {
        this._toastService.error(this.createResult.message, "Error");
      }

      this.merchantreports = await this._reportService.GetAllMerchantsLinksByUser(this.userId);

      this._ngxUiLoaderService.stop();

    }
  }

  public async globalMerchantSearch(value): Promise<void> {
    debugger;
    if (!value.target.checked) {
      this.merchants = await this._reportService.GetAllMerchantsByParticipants("" + this.defaultParticipant);
    }
    else {
      this.merchants = await this._reportService.GetAllMerchants();
    }
  }
}
